import {Component, OnInit, ViewChild} from '@angular/core';
import {NavController, ModalController} from '@ionic/angular';
import {APIService, PermissionType} from 'src/app/API.service';
import {Router} from '@angular/router';
import {EditUserPage} from '../../edit-user/edit-user.page';
import {SessionService} from '../../services/session.service';
import {DataStore, SortDirection} from '@aws-amplify/datastore';
import {User} from '../../../models';
import {ClientsComponent} from '../../components/lists/clients/clients.component';
import {Predicates} from 'aws-amplify';

@Component({
    selector: 'app-clients',
    templateUrl: './clients.page.html',
    styleUrls: ['./clients.page.scss'],
})
export class ClientsPage implements OnInit {
    profile = 'clients';
    sortDirection = SortDirection.ASCENDING;
    clientsList: any;
    @ViewChild('usersList') usersComponent: ClientsComponent;
    cssClass: string;
    showFilters = false;
    filters = {
        name: '',
        role: 'Tutti',
        date:''
    };

    currentPanel = 'elenco';

    constructor(
        public navController: NavController,
        public apiService: APIService,
        public sessionService: SessionService,
        public router: Router,
        public modalController: ModalController,
    ) {
    }

    ngOnInit() {
    }

    async ionViewDidEnter() {
        await this.refreshclientsList();

        // make sure the newly styled content scrolls when needed
        document.querySelectorAll('.main-content')[document.querySelectorAll('.main-content').length-1].shadowRoot.querySelector('.inner-scroll').setAttribute('style', 'height:100%');
    }

    private async refreshclientsList() {
        // this.clientsList = await DataStore.query(User, u => u.role("eq", Roles.CLIENT.displayName));
        const users = await DataStore.query(User,  Predicates.ALL, {
            sort: s => s.lastname(this.sortDirection).name(this.sortDirection),
        });

        this.clientsList = users.filter(u => u.permessions == PermissionType.CLIENT && u.addedBy == this.sessionService.user.id);
        // this.applyClassBySelection('rollIn');
    }

    openUserProfile(userId) {
        this.cssClass = '';
        this.router.navigate(['/profile', userId]);
    }

    async addUser() {
        const modal = await this.modalController.create({
            component: EditUserPage,
            componentProps: {userId: null, isClient: true},
            cssClass: 'custom-modal',
        });
        await modal.present();
        await modal.onWillDismiss().then(data => {
            this.refreshclientsList();
        });
    }

    async edit(userId: string) {
        const modal = await this.modalController.create({
            component: EditUserPage,
            componentProps: {userId: userId},
            cssClass: 'custom-modal',
        });
        await modal.present();
        await modal.onWillDismiss().then(data => {
            this.refreshclientsList();
        });
    }

    async delete(userId: string, i: number) {
        if (confirm('Do you really want to delete this Client')) {
            await DataStore.delete(User, userId);
            // let the animation finish its job
            setTimeout(() => {
                this.refreshclientsList();
            }, 1000);
        }
    }

    applyClassBySelection(effect: string): void {
        this.cssClass = 'animated ' + effect;
    }

    openPage(page: string) {
        return this.router.navigate([page]);
    }

    filterUsers() {
        
            this.usersComponent.filterUsers(this.filters);
    }

    back() {
        this.navController.back();
    }
}
